<template>
    <div class="page">
        <div class="content-section content-page">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-10">
                        <div class="return">
                            <a href="/kwh" class="return_link p-green router-link-active">
                                <img src="../../../img/icon/arrow-down-green.svg" alt="">
                            Vad är kWh (kilowattimme)?
                        </a></div>
                        <h1>Instructions Price</h1>
                        <page-navigation></page-navigation>
                        <h3 class="border__btm">What is an instructional price for electricity?</h3>


                        <p>Instruction agreement, advance price, single price, normal price, instruction fee or advance agreement - dear child has many names. However, what is common to these agreements is that it is the electricity contract that a customer is awarded when they do not make an active choice. Instruction price is also by far the most expensive form of agreement available on the Swedish market. Therefore, one should usually make sure to avoid assignment agreements in order not to pay an expensive electricity price unnecessarily. The most common case when awarding an assignment agreement is that you have moved into a new home and have not chosen an agreement on your own. When you move, there can be many other things that will end up in the place and that you need to stand in. It can also be that you are not sure how to even change an electricity contract, or which player is the cheapest in the area you have moved. to.</p>

                        <h3 class="border__btm">Avoid directions and save money</h3>
                        <p>As a rule, all electricity contracts are cheaper than the instructions contracts that are awarded. This is why you should actively choose an electricity contract before moving in. However, there can be a big difference between electricity contracts and electricity contracts. This is why you should always make a free comparison of the electricity contracts that can be signed in your area with TecknaEl. This way you can save money on the electricity bill every month even if you do not have an electricity contract with a guide price. Comparison services such as TecknaEl also give you good advice when choosing electricity companies, as it can otherwise be difficult to get into the electricity market. This allows you to easily save money on the energy bill .</p>

                        <h3 class="border__btm">Compare electricity contracts and find the best agreement</h3>
                        <p>It is not unusual to find yourself with a contract for electricity. In fact, almost every seventh household in Sweden already has a licensing agreement today, since they have not made an active choice of electricity companies. This means that hundreds of thousands of households pay a far, much higher electricity price than they really needed. Whether you choose an electricity contract with a variable or fixed price, you can expect this to be cheaper than an assignment agreement. In short, the guide price is something that consumers should avoid - but at the same time it can be difficult to gain insight into the electricity market and know what to choose. Simply put it isa electricity companies cheaper than the terms you get with a guide price for electricity. Therefore, use TecknaEl today to Compare different electricity contracts in your area, och hitta rätt val för dig - oavsett om detta är det avtal som är mest miljövänligt eller billigast.</p>

                        <h3 class="border__btm">Electricity area 1</h3>
                        <div class="table">
                            <table class=" first-col-blue last-col-green">
                            <thead>
                                <tr>
                                    <th>Company</th>
                                    <th>Agreement type</th>
                                    <th>Default rate</th>
                                    <th>Electricity price</th>
                                    <th>%</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                    <td>Additional price "Refers to electricity area 3)</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                    <td>Additional price "Refers to electricity area 3)</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                    <td>Additional price "Refers to electricity area 3)</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                    <td>Additional price "Refers to electricity area 3)</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                    <td>Additional price "Refers to electricity area 3)</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                    <td>Additional price "Refers to electricity area 3)</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                    <td>Additional price "Refers to electricity area 3)</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                                <tr>
                                    <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                    <td>Fortum Simple</td>
                                    <td>117.09 öre / kWh</td>
                                    <td>62.34 öre / kWh</td>
                                    <td>47%</td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                        <br />
                        <h3 class="border__btm">Electricity area 2</h3>
                        <div class="table">
                            <table class=" first-col-blue last-col-green">
                            <thead>
                            <tr>
                                <th>Company</th>
                                <th>Agreement type</th>
                                <th>Default rate</th>
                                <th>Electricity price</th>
                                <th>%</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                <td>Additional price "Refers to electricity area 3)</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                <td>Additional price "Refers to electricity area 3)</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                <td>Additional price "Refers to electricity area 3)</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                <td>Additional price "Refers to electricity area 3)</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                <td>Additional price "Refers to electricity area 3)</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                <td>Additional price "Refers to electricity area 3)</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/fortum.svg" alt=""> <p>Fortum</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/gotlands_elforsaljning_ab.png" alt=""> <p>Gotland's Electricity Sales</p></td>
                                <td>Additional price "Refers to electricity area 3)</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            <tr>
                                <td><img src="../../../img/vasterbergslagens_elforsaljning_ab.png" alt=""> <p>Västerberglagen's Electricity Sales</p></td>
                                <td>Fortum Simple</td>
                                <td>117.09 öre / kWh</td>
                                <td>62.34 öre / kWh</td>
                                <td>47%</td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import PageNavigation from './page-part/pageNavigation'
    export default {
        name: "InstructionPage",
        components: {
            PageNavigation,

        },

    }
</script>
